import React, { useState } from 'react';
import useApiPost from '../hooks/postData';
import toast from 'react-hot-toast';

function TransactionPin() {
  const { postData, loading } = useApiPost();
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");

  const handleSetPin = async () => {
    if (!/^\d{4}$/.test(pin)) {
      toast.error("PIN must be exactly 4 digits");
      return;
    }
    if (pin !== confirmPin) {
      toast.error("PINs do not match");
      return;
    }
    try {
      const res = await postData("/set_transaction_pin", { pin });
      if (res?.success) {
        toast.success(res.message || "PIN set successfully!");
        setPin("");
        setConfirmPin("");
      } else {
        toast.error(res?.message || "Failed to set PIN");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-6">
      <h2 className="text-base font-semibold font-poppins text-header pb-1">Transaction PIN</h2>
      <p className="text-xs font-poppins text-[#777777] pb-4">
        Set a 4-digit PIN. This PIN will be required every time you add or deduct coins from a user's wallet.
      </p>
      <div className="grid gap-4 md:grid-cols-2 max-w-md">
        <div>
          <label className="text-sm font-semibold font-poppins dark:text-darkText">New PIN</label>
          <input
            type="password"
            maxLength={4}
            inputMode="numeric"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
            className="border border-opacity-gradient dark:bg-transparent dark:text-darkText dark:border-borderColor rounded-lg w-full py-3 my-1 px-4 focus:outline-none focus:ring-1 focus:ring-header tracking-widest"
            placeholder="••••"
          />
        </div>
        <div>
          <label className="text-sm font-semibold font-poppins dark:text-darkText">Confirm PIN</label>
          <input
            type="password"
            maxLength={4}
            inputMode="numeric"
            value={confirmPin}
            onChange={(e) => setConfirmPin(e.target.value.replace(/\D/g, ""))}
            className="border border-opacity-gradient dark:bg-transparent dark:text-darkText dark:border-borderColor rounded-lg w-full py-3 my-1 px-4 focus:outline-none focus:ring-1 focus:ring-header tracking-widest"
            placeholder="••••"
          />
        </div>
      </div>
      <button
        onClick={handleSetPin}
        disabled={loading}
        style={{ backgroundColor: '#593A99' }}
        className="mt-5 px-8 py-2.5 text-sm font-medium text-white rounded-lg font-poppins"
      >
        {loading ? "Saving..." : "Save PIN"}
      </button>
    </div>
  );
}

export default TransactionPin;